module.exports = __webpack_public_path__ + "media/images/redesign-images/home/carousel/college-desktop-5268e9fdc1e0772a140a1c3cbe36eb66.jpg";